import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import PoolIcon from './PoolIcon';
import ShutterStoreIcon from './ShutterStoreIcon';
import PowerIcon from './PowerIcon';
import SwitchIcon from './SwitchIcon';
import ProbeIcon from './ProbeIcon';
import WaterSensorIcon from './WaterSensorIcon';
import SmokeDetectorIcon from './SmokeDetectorIcon';
import DimmerIcon from './DimmerIcon';
import DoorSensorIcon from './DoorSensorIcon';
import MotionSensorIcon from './MotionSensorIcon';
import ClampIcon from './ClampIcon';
import WaterFlowMeter from './WaterFlowMeter';
import GasFlowMeter from './GasFlowMeter';
import WattFlowMeter from './WattFlowMeter';
import FlowMeterIcon from './FlowMeter';
import WashingMachineIcon from './WashingMachineIcon';
import DishWasherIcon from './DishWasherIcon';
import DryerIcon from './DryerIcon';
import CoffeeMakerIcon from './CoffeeMakerIcon';
import FridgeIcon from './FridgeIcon';
import FreezerIcon from './FreezerIcon';
import TVIcon from './TVIcon';
import HiFiIcon from './HiFiIcon';
import ECSIcon from './ECSIcon';
import PCIcon from './PCIcon';
import LightBulbIcon from './LightBulbIcon';
import PACIcon from './PACIcon';
import RadiateurIcon from './RadiateurIcon';
import SplitIcon from './SplitIcon';
import SmartPlugIcon from './SmartPlugIcon';
import SDM18HCLIcon from './SDM18HCLIcon';
import BoxIcon from './BoxIcon';
import AirzoneIcon from './SvgAirzone';
import SDM20LHTIcon from './SvgSDM20LHT';

let appliance_components = {
    default: PowerIcon,
    power: PowerIcon,
    pool: PoolIcon,
    shutterstore: ShutterStoreIcon,
    switch: SwitchIcon,
    probe: ProbeIcon,
    water_sensor: WaterSensorIcon,
    smoke_detector: SmokeDetectorIcon,
    dimmer: DimmerIcon,
    door_sensor: DoorSensorIcon,
    motion_sensor: MotionSensorIcon,
    clamp: ClampIcon,
    relay: SwitchIcon,
    flowmeter: FlowMeterIcon,
    water_flowmeter: WaterFlowMeter,
    gas_flowmeter: GasFlowMeter,
    watt_flowmeter: WattFlowMeter,
    washingmachine: WashingMachineIcon,
    dishwasher: DishWasherIcon,
    dryer: DryerIcon,
    coffeemaker: CoffeeMakerIcon,
    fridge: FridgeIcon,
    freezer: FreezerIcon,
    tv: TVIcon,
    HiFi: HiFiIcon,
    ecs: ECSIcon,
    pc: PCIcon,
    lightbulb: LightBulbIcon,
    pac: PACIcon,
    radiateur: RadiateurIcon,
    split: SplitIcon,
    smartplug: SmartPlugIcon,
    SDM18HCL: SDM18HCLIcon,
    pilotwire: RadiateurIcon,
    box: BoxIcon,
    airzone: AirzoneIcon,
    SDM20LHT: SDM20LHTIcon
};

export default class ApplianceIconComponent extends PureComponent {
    static propTypes = {
        name: PropTypes.string,
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        productModule: PropTypes.object,
        productType: PropTypes.string,
        moduleType: PropTypes.string,
        productLineType: PropTypes.string,
        productLineTypeDiversity: PropTypes.string,
        productImage: PropTypes.string
    };

    static defaultProps = {
        productModule: null,
        productType: null,
        moduleType: null,
        productLineType: null,
        productLineTypeDiversity: null,
        productImage: null
    };

    render() {
        let IconComponent = null;

        let {
            name,
            size,
            color,
            secondaryColor,
            productModule,
            productType,
            moduleType,
            productLineType,
            productLineTypeDiversity,
            productImage,
            ...restParams
        } = this.props;

        if (productModule) {
            productType = productModule.get('productType');
            moduleType = productModule.get('type');
            productLineType = productModule.get('lineType');
            productLineTypeDiversity = productModule.get('lineTypeDiversity');
            productImage = productModule.get('imageName');
        }

        if (typeof name === 'undefined' && productImage) name = productImage;
        else if (typeof name === 'undefined') name = 'default';

        if (name === 'default' && (typeof productType !== 'undefined' || typeof moduleType !== 'undefined')) {
            if (productType === 'fhe_product' && moduleType === 'SDM17SPG') {
                name = 'smartplug';
            } else if (productType === 'fhe_product') {
                switch (productLineType) {
                    case 'relay':
                        name = 'relay';
                        break;
                    case 'clamp':
                        name = 'clamp';
                        break;
                    case 'probe':
                        name = 'probe';
                        break;
                    case 'flowmeter':
                        if (productLineTypeDiversity) {
                            name = productLineTypeDiversity + '_flowmeter';
                        } else {
                            name = 'flowmeter';
                        }
                        break;
                    case 'pilotwire':
                        name = 'pilotwire';
                        break;
                    default:
                        name = moduleType;
                        break;
                }
            } else if (productType === 'sensor') {
                switch (productLineType) {
                    case 'relay':
                        name = 'relay';
                        break;
                    case 'clamp':
                        name = 'clamp';
                        break;
                    default:
                        name = moduleType;
                        break;
                }
            } else if (productType === 'drive_elec') {
                switch (productLineType) {
                    case 'relay':
                        name = 'relay';
                        break;
                    case 'clamp':
                        name = 'clamp';
                        break;
                    default:
                        name = moduleType;
                        break;
                }
            }
        }

        if (!name || typeof appliance_components[name] === 'undefined') IconComponent = appliance_components['default'];
        else IconComponent = appliance_components[name];

        return <IconComponent size={size} color={color} secondaryColor={secondaryColor} {...restParams} />;
    }
}



// WEBPACK FOOTER //
// ./data/common/iconsvg/ApplianceIconComponent.js